__webpack_require__.p = "/animex/";